module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<h2 class=\"video-section-title\">")
    ; __append(escapeFn( title ))
    ;  if (typeof redDot !== 'undefined' && redDot === true) { 
    ; __append("\n    <div class=\"reddot\"></div>\n    ")
    ;  } 
    ; __append(" ")
    ;  if (typeof todaysDate !== 'undefined') { 
    ; __append("<span class=\"schedule-header-date\" style=\"display: none;\">Today ")
    ; __append(escapeFn(  todaysDate ))
    ; __append("</span>")
    ; 
    } 
    ; __append("\n    \n</h2>\n")
    ;  if (typeof callSignOrChannelName !== 'undefined' && callSignOrChannelName) { 
    ; __append("\n<span class=\"extended-carousel-title\">")
    ; __append(escapeFn( callSignOrChannelName ))
    ; __append("</span>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (typeof editable !== 'undefined') { 
    ; __append("\n<div class=\"edit-carousel\" tabindex=\"0\">\n    ")
    ; __append(escapeFn( getLocale('edit') ))
    ; __append("\n</div>\n<div class=\"edit-cancel-carousel\">\n    ")
    ; __append(escapeFn( getLocale('cancel') ))
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n\n<ul class=\"dropdown dropdown__filter js-dropdown\"></ul>\n<div class=\"video-carousel-box\">\n    <div class=\"wrap swiper-container\">\n        <div class=\"carousel-container swiper-wrapper\">\n        </div>\n        <a class=\"carousel-prev focusable\"></a>\n        <a class=\"carousel-next focusable\"></a>\n    </div>\n    <div class=\"message-box\"></div>\n</div>")
  }
  return __output;

}